export const TABLE_HEADER_CELLS = [
  'creativeUniqueId',
  'currentEarnings',
  'previousEarnings',
  'lifetimeEarnings',
];
